
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import ValueProposition from './components/ValueProposition';
import TargetIndustries from './components/TargetIndustries';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import Navigation from './components/Navigation';

export default function Home() {
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['home', 'value', 'industries', 'contact'];
      const scrollPosition = window.scrollY + 150;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-[#080808]">
      <Navigation activeSection={activeSection} />
      <Hero />
      <ValueProposition />
      <TargetIndustries />
      <ContactSection />
      <Footer />
    </div>
  );
}
